import _styled from '@emotion/styled/base';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef, useState, useRef, useCallback, useMemo, useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { IconButton, FormLabel, Typography } from '@kaltura/ds-react-components';
import { Bold24Icon, Italic24Icon, Underline24Icon, Bulletlist24Icon, OrderedList24Icon, Image24Icon, Link24Icon } from '@kaltura/ds-react-icons';
import { v4 } from 'uuid';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$a = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$9 = fails$a;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$9(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString$3 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$3.call(it).slice(8, -1);
};

var fails$8 = fails$a;
var classof$6 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$8(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$6(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$4 = function (it) {
  return IndexedObject$4(requireObjectCoercible$3(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$b = function (argument) {
  return typeof argument === 'function';
};

var isCallable$a = isCallable$b;

var isObject$7 = function (it) {
  return typeof it === 'object' ? it !== null : isCallable$a(it);
};

var global$c = global$d;
var isCallable$9 = isCallable$b;

var aFunction = function (argument) {
  return isCallable$9(argument) ? argument : undefined;
};

var getBuiltIn$5 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var getBuiltIn$4 = getBuiltIn$5;

var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$7 = fails$a;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$7(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var isCallable$8 = isCallable$b;
var getBuiltIn$3 = getBuiltIn$5;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$3('Symbol');
  return isCallable$8($Symbol) && Object(it) instanceof $Symbol;
};

var tryToString$1 = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$7 = isCallable$b;
var tryToString = tryToString$1;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$7(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$2(func);
};

var isCallable$6 = isCallable$b;
var isObject$6 = isObject$7;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$6(fn = input.toString) && !isObject$6(val = fn.call(input))) return val;
  if (isCallable$6(fn = input.valueOf) && !isObject$6(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable$6(fn = input.toString) && !isObject$6(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$a = global$d;

var setGlobal$3 = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var requireObjectCoercible$2 = requireObjectCoercible$4;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return Object(requireObjectCoercible$2(argument));
};

var toObject$4 = toObject$5;

var hasOwnProperty = {}.hasOwnProperty;

var has$7 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$4(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$8 = global$d;
var shared$2 = shared$3.exports;
var has$6 = has$7;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$8.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$7 = function (name) {
  if (!has$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$6 = wellKnownSymbol$7;

var TO_PRIMITIVE = wellKnownSymbol$6('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};

var global$7 = global$d;
var isObject$4 = isObject$7;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$6 = descriptors;
var fails$6 = fails$a;
var createElement = documentCreateElement$2;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$6 && !fails$6(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$5 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var has$5 = has$7;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$5(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$3 = isObject$7;

// `Assert: Type(argument) is Object`
var anObject$4 = function (argument) {
  if (isObject$3(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$3 = anObject$4;
var toPropertyKey = toPropertyKey$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$3(O);
  P = toPropertyKey(P);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$4 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$1 = {exports: {}};

var isCallable$5 = isCallable$b;
var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$5(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$4 = isCallable$b;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$6.WeakMap;

var nativeWeakMap = isCallable$4(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$2 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$d;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var objectHas = has$7;
var shared = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$5.WeakMap;
var set, get, has$4;

var enforce = function (it) {
  return has$4(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$4 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$4 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$4,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$2 = descriptors;
var has$3 = has$7;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = has$3(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$4 = global$d;
var isCallable$3 = isCallable$b;
var has$2 = has$7;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule = internalState;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$3(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty$2(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$4) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$2(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$3(this) && getInternalState(this).source || inspectSource$1(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$2 = toLength$3;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$2(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var has$1 = has$7;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$2, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$2 = getBuiltIn$5;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$2 = anObject$4;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$2(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$7;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$5 = fails$a;
var isCallable$2 = isCallable$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$2(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$3 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$3;
  } else if (STATIC) {
    target = global$3[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$3[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var wellKnownSymbol$5 = wellKnownSymbol$7;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$b;
var classofRaw = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$7;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof$4 = classof$5;

var toString$2 = function (argument) {
  if (classof$4(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

var requireObjectCoercible$1 = requireObjectCoercible$4;
var toString$1 = toString$2;

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = toString$1(requireObjectCoercible$1(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString$1(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

var fails$4 = fails$a;

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails$4(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

var $$9 = _export;
var createHTML$2 = createHtml;
var forcedStringHTMLMethod$2 = stringHtmlForced;

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$$9({ target: 'String', proto: true, forced: forcedStringHTMLMethod$2('bold') }, {
  bold: function bold() {
    return createHTML$2(this, 'b', '', '');
  }
});

var $$8 = _export;
var createHTML$1 = createHtml;
var forcedStringHTMLMethod$1 = stringHtmlForced;

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$$8({ target: 'String', proto: true, forced: forcedStringHTMLMethod$1('italics') }, {
  italics: function italics() {
    return createHTML$1(this, 'i', '', '');
  }
});

var $$7 = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced;

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$$7({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$1 = descriptors;
var fails$3 = fails$a;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$5;
var IndexedObject$3 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$3(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$6 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$6({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

var DESCRIPTORS = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var anObject$1 = anObject$4;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$1 = getBuiltIn$5;

var html$1 = getBuiltIn$1('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject = anObject$4;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey = sharedKey$2;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$3 = wellKnownSymbol$7;
var create = objectCreate;
var definePropertyModule = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$3('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$5 = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables = addToUnscopables$1;

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$5({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject$1 = isObject$7;
var classof$3 = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$7;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$3(it) == 'RegExp');
};

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$7;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$4 = _export;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$4;
var toString = toString$2;
var correctIsRegExpLogic = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$4({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~toString(requireObjectCoercible(this))
      .indexOf(toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var aCallable$1 = aCallable$3;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aCallable$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var classof$2 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$2(argument) == 'Array';
};

var fails$2 = fails$a;
var isCallable = isCallable$b;
var classof$1 = classof$5;
var getBuiltIn = getBuiltIn$5;
var inspectSource = inspectSource$3;

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$7;
var wellKnownSymbol = wellKnownSymbol$7;

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var IndexedObject$2 = indexedObject;
var toObject$2 = toObject$5;
var toLength$1 = toLength$3;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$2($this);
    var self = IndexedObject$2(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var fails$1 = fails$a;

var arrayMethodIsStrict$3 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$3;

var STRICT_METHOD$2 = arrayMethodIsStrict$2('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var $$3 = _export;
var forEach$1 = arrayForEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$$3({ target: 'Array', proto: true, forced: [].forEach != forEach$1 }, {
  forEach: forEach$1
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$d;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var forEach = arrayForEach;
var createNonEnumerableProperty = createNonEnumerableProperty$4;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);

var $$2 = _export;
var toObject$1 = toObject$5;
var nativeKeys = objectKeys$2;
var fails = fails$a;

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$2({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject$1(it));
  }
});

var $$1 = _export;
var IndexedObject$1 = indexedObject;
var toIndexedObject = toIndexedObject$4;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$3;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject$1 != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict$1('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$1({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var aCallable = aCallable$3;
var toObject = toObject$5;
var IndexedObject = indexedObject;
var toLength = toLength$3;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var classof = classofRaw$1;
var global$1 = global$d;

var engineIsNode = classof(global$1.process) == 'process';

var $ = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$3;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

function composeClasses(slots, getUtilityClass, classes) {
  var output = {};
  Object.keys(slots).forEach( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  function (slot) {
    output[slot] = slots[slot].reduce(function (acc, key) {
      if (key) {
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }

        acc.push(getUtilityClass(key));
      }

      return acc;
    }, []).join(" ");
  });
  return output;
}

var globalPseudoClassesMapping = {
  active: "__private__-active",
  checked: "__private__-checked",
  disabled: "__private__-disabled",
  error: "__private__-error",
  focused: "__private__-focused",
  focusVisible: "__private__-focusVisible",
  required: "__private__-required",
  expanded: "__private__-expanded",
  selected: "__private__-selected"
};
function generateUtilityClass(componentName, slot) {
  var globalPseudoClass = globalPseudoClassesMapping[slot];
  return globalPseudoClass || componentName + "-" + slot;
}

function generateUtilityClasses(componentName, slots) {
  var result = {};
  slots.forEach(function (slot) {
    result[slot] = generateUtilityClass(componentName, slot);
  });
  return result;
}

var RICH_TEXT_COMPONENT_NAME = "__private__-richtext";
function getRichTextClass(slot) {
  return generateUtilityClass(RICH_TEXT_COMPONENT_NAME, slot);
}
var richTextClasses = generateUtilityClasses(RICH_TEXT_COMPONENT_NAME, ["root", "richText", "toolbar", "readOnly", "error", "focused"]);

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var icons = Quill["import"]('ui/icons');
icons.bold = null;
icons.italic = null;
icons.underline = null;
icons.color = null;
icons.image = null;
icons.link = null;
icons.bullet = null;
icons.list = null;
var block = Quill["import"]("blots/block"); // setting the wrapping tag element to be `div`:

block.tagName = "div";
Quill.register(block, true);
var ESupportedActions;

(function (ESupportedActions) {
  ESupportedActions["Bold"] = "Bold";
  ESupportedActions["Italic"] = "Italic";
  ESupportedActions["Underline"] = "Underline";
  ESupportedActions["List"] = "List";
  ESupportedActions["Image"] = "Image";
  ESupportedActions["Link"] = "Link";
})(ESupportedActions || (ESupportedActions = {}));

var ALL_ACTIONS = [ESupportedActions.Bold, ESupportedActions.Italic, ESupportedActions.Underline, ESupportedActions.List, ESupportedActions.Image, ESupportedActions.Link];

var useUtilityClasses = function useUtilityClasses(props) {
  var classes = props.classes;
  var slots = {
    root: ["root"],
    richText: ["richText"],
    readOnly: ["readOnly"],
    error: ["error"],
    focused: ["focused"],
    toolbar: ["toolbar"]
  };
  return composeClasses(slots, getRichTextClass, classes);
};

var FORMATS = ["header", "font", "size", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link", "image", "color"];

var StyledInputContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eq5df7t3"
} : {
  target: "eq5df7t3",
  label: "StyledInputContainer"
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    width: '100%',
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative'
  }, _ref2["&." + richTextClasses.readOnly] = {
    background: theme.kaltura.palette.tone7
  }, _ref2;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var StyledInputError = _styled("label", process.env.NODE_ENV === "production" ? {
  target: "eq5df7t2"
} : {
  target: "eq5df7t2",
  label: "StyledInputError"
})(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.kaltura.palette.danger.main,
    marginTop: theme.spacing(1),
    display: 'block'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var StyledInputWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eq5df7t1"
} : {
  target: "eq5df7t1",
  label: "StyledInputWrapper"
})(function (_ref4) {
  var _qlTooltip, _qlContainerQlS, _ref5;

  var theme = _ref4.theme,
      focused = _ref4.focused,
      error = _ref4.error,
      readonly = _ref4.readonly;
  return _ref5 = {
    position: 'relative',
    alignItems: 'center',
    borderRadius: theme.kaltura.shape.roundness1,
    border: "1px solid " + (readonly ? theme.kaltura.palette.tone4 : focused ? theme.kaltura.palette.primary.main : error ? theme.kaltura.palette.danger.main : theme.kaltura.palette.tone4)
  }, _ref5['& .ql-container.ql-snow'] = (_qlContainerQlS = {
    fontFamily: theme.typography.fontFamily,
    border: 'none'
  }, _qlContainerQlS['& .ql-editor'] = {
    padding: "0 " + theme.spacing(2) + " " + theme.spacing(2)
  }, _qlContainerQlS['& .ql-tooltip'] = (_qlTooltip = {
    borderRadius: theme.kaltura.shape.roundness1
  }, _qlTooltip['& .ql-action, & .ql-remove'] = {
    color: theme.kaltura.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold
  }, _qlTooltip['&[data-mode=image]::before'] = {
    content: '"Enter image URL:"'
  }, _qlTooltip), _qlContainerQlS), _ref5;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var StyledToolBar = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eq5df7t0"
} : {
  target: "eq5df7t0",
  label: "StyledToolBar"
})(function (_ref6) {
  var _button, _qlSnowQlToolbar, _ref7;

  var theme = _ref6.theme;
  return _ref7 = {
    borderTopLeftRadius: theme.kaltura.shape.roundness1,
    borderTopRightRadius: theme.kaltura.shape.roundness1
  }, _ref7['&.ql-snow.ql-toolbar'] = (_qlSnowQlToolbar = {
    border: 'none'
  }, _qlSnowQlToolbar['& button'] = (_button = {
    width: 'inherit',
    height: 'inherit',
    color: theme.kaltura.palette.tone1,
    marginRight: theme.spacing(1)
  }, _button['&.ql-active'] = {
    backgroundColor: theme.kaltura.palette.tone6
  }, _button['&:disabled'] = {
    color: theme.kaltura.palette.tone4
  }, _button), _qlSnowQlToolbar), _ref7;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Richtext = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      defaultValue = props.defaultValue,
      valueProp = props.value,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      _props$supportedActio = props.supportedActions,
      supportedActions = _props$supportedActio === void 0 ? ALL_ACTIONS : _props$supportedActio;
  var classes = useUtilityClasses(props);

  var _useState = useState(valueProp || defaultValue || ''),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = useState(false),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(false),
      hasSelection = _useState3[0],
      setHasSelection = _useState3[1];

  var _useState4 = useState(v4()),
      richTextUUID = _useState4[0];

  var reactQuillRef = useRef(null);

  var handleChange = function handleChange(content, delta, source) {
    setValue(content);
    source === 'user' && !!onChange && onChange(content);
  };

  var handleSelectionChange = function handleSelectionChange(range) {
    setHasSelection(!!(range === null || range === void 0 ? void 0 : range.length));
  };

  var onFieldFocus = function onFieldFocus() {
    setFocused(true);
    onFocus && onFocus();
  };

  var onFieldBlur = function onFieldBlur() {
    setFocused(false);
    onBlur && onBlur();
  };

  var imageHandler = useCallback(function () {
    var _a; // need a ref to the quill object for this to work:


    if (!reactQuillRef.current || typeof ((_a = reactQuillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor) !== 'function') {
      return;
    }

    var quill = reactQuillRef.current.getEditor(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    var tooltip = quill.theme.tooltip; // keep a reference to the original tooltip methods that are used for other (built-in) prompts:

    var originalSave = tooltip.save;
    var originalHide = tooltip.hide; // override tooltip prompt to get a url for images:

    tooltip.save = function () {
      var range = quill.getSelection(true);
      var value = tooltip.textbox.value;
      quill.insertEmbed(range.index, 'image', value, "user");
    }; // Called on hide and save.


    tooltip.hide = function () {
      // restore original methods
      tooltip.save = originalSave;
      tooltip.hide = originalHide;
      tooltip.hide();
    }; // trigger prompt:


    tooltip.edit('image');
  }, [reactQuillRef]);
  var RichTextToolBar = useMemo(function () {
    return jsxs(StyledToolBar, Object.assign({
      id: "toolbar-" + richTextUUID,
      className: classes.toolbar
    }, {
      children: [supportedActions.includes(ESupportedActions.Bold) && jsx(IconButton, Object.assign({
        variant: "borderless",
        className: "ql-bold",
        disabled: readOnly
      }, {
        children: jsx(Bold24Icon, {}, void 0)
      }), void 0), supportedActions.includes(ESupportedActions.Italic) && jsx(IconButton, Object.assign({
        variant: "borderless",
        className: "ql-italic",
        disabled: readOnly
      }, {
        children: jsx(Italic24Icon, {}, void 0)
      }), void 0), supportedActions.includes(ESupportedActions.Underline) && jsx(IconButton, Object.assign({
        variant: "borderless",
        className: "ql-underline",
        disabled: readOnly
      }, {
        children: jsx(Underline24Icon, {}, void 0)
      }), void 0), supportedActions.includes(ESupportedActions.List) && jsxs(Fragment, {
        children: [jsx(IconButton, Object.assign({
          variant: "borderless",
          className: "ql-list",
          value: "bullet",
          disabled: readOnly
        }, {
          children: jsx(Bulletlist24Icon, {}, void 0)
        }), void 0), jsx(IconButton, Object.assign({
          variant: "borderless",
          className: "ql-list",
          value: "ordered",
          disabled: readOnly
        }, {
          children: jsx(OrderedList24Icon, {}, void 0)
        }), void 0)]
      }, void 0), supportedActions.includes(ESupportedActions.Image) && jsx(IconButton, Object.assign({
        variant: "borderless",
        className: "ql-image",
        disabled: readOnly
      }, {
        children: jsx(Image24Icon, {}, void 0)
      }), void 0), supportedActions.includes(ESupportedActions.Link) && jsx(IconButton, Object.assign({
        variant: "borderless",
        className: "ql-link",
        disabled: readOnly || !hasSelection
      }, {
        children: jsx(Link24Icon, {}, void 0)
      }), void 0)]
    }), void 0);
  }, [readOnly, hasSelection, classes, richTextUUID]);
  useEffect(function () {
    if (valueProp) {
      setValue(valueProp);
    }
  }, [valueProp]);
  return jsxs(StyledInputContainer, Object.assign({
    ref: ref,
    id: "rich-text-container-" + richTextUUID,
    className: clsx(classes.root, readOnly ? classes.readOnly : '', focused ? classes.focused : '', errorMessage ? classes.error : '')
  }, {
    children: [label && jsx(FormLabel, {
      controlID: RICH_TEXT_COMPONENT_NAME,
      label: label
    }, void 0), jsxs(StyledInputWrapper, Object.assign({
      focused: focused,
      error: !!errorMessage,
      readonly: readOnly
    }, {
      children: [RichTextToolBar, jsx(ReactQuill, {
        ref: reactQuillRef,
        value: value,
        onFocus: onFieldFocus,
        onBlur: onFieldBlur,
        onChange: handleChange,
        onChangeSelection: handleSelectionChange,
        placeholder: placeholder,
        modules: {
          toolbar: {
            container: "#toolbar-" + richTextUUID,
            handlers: {
              image: imageHandler
            }
          },
          keyboard: {
            bindings: {
              tab: false
            }
          }
        },
        formats: FORMATS,
        readOnly: readOnly,
        className: classes.richText,
        bounds: "#rich-text-container-" + richTextUUID
      }, void 0)]
    }), void 0), errorMessage && jsx(Typography, Object.assign({
      variant: 'formError'
    }, {
      children: jsx(StyledInputError, {
        children: errorMessage
      }, void 0)
    }), void 0)]
  }), void 0);
});

export { ALL_ACTIONS, ESupportedActions, RICH_TEXT_COMPONENT_NAME, Richtext, getRichTextClass, richTextClasses };
